import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M14.4 8A6.4 6.4 0 1 1 1.6 8a6.4 6.4 0 0 1 12.8 0m-1.2 0a5.2 5.2 0 1 1-8.8-3.752v.358a2.8 2.8 0 0 0 .82 1.98L6.634 8l-.234.234a.8.8 0 0 0 0 1.132l.848.848a1.2 1.2 0 0 1 .352.849v.29a.8.8 0 0 0 .442.715l.221.111a.8.8 0 0 0 1.073-.358L10.5 9.495a1.2 1.2 0 0 0-.224-1.385l-.618-.618A.8.8 0 0 0 8.84 7.3L8.53 7.4a.4.4 0 0 1-.484-.2l-.237-.474a.385.385 0 0 1 .517-.516l.21.105a.8.8 0 0 0 .357.084h.15a.8.8 0 0 0 .76-1.053l-.055-.163a.4.4 0 0 1 .12-.43l1.15-.987A5.2 5.2 0 0 1 13.2 8",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }